export default "__VITE_ASSET__73fbaae1__"